export type EmissaoStatus =
  | "rascunho"
  | "pronta_para_emitir"
  | "emissao"
  | "enviada_para_emitir"
  | "emitida"
  | "erro_emissao"
  | "cancelada"

export const EMISSAO_STATUS_LABELS: Record<EmissaoStatus, string> = {
  rascunho: "Rascunho",
  pronta_para_emitir: "Pronta para emitir",
  emissao: "Emissão",
  enviada_para_emitir: "Emissão",
  emitida: "Emitida",
  erro_emissao: "Erro na emissão",
  cancelada: "Cancelada"
}

function normalizeStatus(status: string | undefined | null) {
  const s = status?.toString().trim()
  return s && s.length > 0 ? s : "rascunho"
}

export function emissaoStatusLabel(status: string | undefined | null) {
  const s = normalizeStatus(status)
  return EMISSAO_STATUS_LABELS[s as EmissaoStatus] ?? s.replace(/_/g, " ")
}

export function EmissaoStatusBadge({ status }: { status: string | undefined | null }) {
  const s = normalizeStatus(status)
  const base = "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium"
  const styles: Record<string, string> = {
    rascunho: "bg-slate-700/80 text-slate-200",
    pronta_para_emitir: "bg-indigo-900/50 text-indigo-200 ring-1 ring-indigo-700/40",
    emissao: "bg-sky-900/60 text-sky-200 ring-1 ring-sky-700/50",
    enviada_para_emitir: "bg-sky-900/60 text-sky-200 ring-1 ring-sky-700/50",
    emitida: "bg-emerald-900/50 text-emerald-200 ring-1 ring-emerald-700/40",
    erro_emissao: "bg-rose-900/50 text-rose-200 ring-1 ring-rose-700/40",
    cancelada: "bg-zinc-800 text-zinc-300 ring-1 ring-zinc-600/50"
  }
  const cls = `${base} ${styles[s] ?? "bg-slate-800 text-slate-300"}`
  return <span className={cls}>{emissaoStatusLabel(s)}</span>
}
